import { RESET_ERRORS } from 'store/types'

export const resetErrorsAction = (payload) => ({
  type: RESET_ERRORS,
  payload,
})
